import type { Icon } from "@tabler/icons-react";
import { IconCloudDownload, IconFileCertificate } from "@tabler/icons-react";
import type { GeneratorOverview } from "../../../../../../utils/backend-types";

export enum GeneratorFeatureKeys {
  isRedispatchImportActive = "is_redispatch_import_active",
  isVollmachtProvided = "emsys.is_vollmacht_provided"
}

export type GeneratorFeature = {
  label: string;
  key: GeneratorFeatureKeys;
  overviewKey?: keyof GeneratorOverview;
  icon: Icon;
  confirmationText?: string;
  generatorCondition?: keyof GeneratorOverview;
  staffOnly?: boolean;
};

export const GENERATOR_FEATURES: Array<GeneratorFeature> = [
  {
    label: "Redispatch/DVA Import",
    key: GeneratorFeatureKeys.isRedispatchImportActive,
    icon: IconCloudDownload,
    confirmationText:
      "Möchten Sie wirklich den automatischen Datenimport von Energiemengen aus Redispatch- und Direktvermarkter-Abregelungen für diese Anlage beenden?",
    staffOnly: true,
    generatorCondition: "is_redispatch_import_active_for_operator"
  },
  {
    label: "Vollmacht übermittelt",
    key: GeneratorFeatureKeys.isVollmachtProvided,
    overviewKey: "is_vollmacht_provided",
    icon: IconFileCertificate,
    confirmationText:
      "Möchten Sie wirklich den Status 'Vollmacht übermittelt' für diese Anlage entfernen?",
    staffOnly: true,
    generatorCondition: "is_redispatch_import_active_for_operator"
  }
];
